// File: carWizardTypes
// Created: 2026-05-12
// Updated: 2026-05-12
// Author: Erick Hernández Silva

export interface ViewImages {
  view1?: string;
  view2?: string;
  view3?: string;
  view4?: string;
  view5?: string;
  view6?: string;
}

export const VIEW_KEYS = ['view1', 'view2', 'view3', 'view4', 'view5', 'view6'] as const;
export type ViewKey = (typeof VIEW_KEYS)[number];
export type PreferredView = ViewKey | 'no_change';

export interface SubOption {
  optionId: string;
  optionName: string;
  optionPrice: number;
  images: ViewImages;
  isDefault?: boolean;
}

export interface Option {
  optionId: string;
  optionName: string;
  optionDescription?: string;
  optionPrice: number;
  presentationImage?: string;
  images: ViewImages;
  subOptions?: SubOption[];
  isDefault?: boolean;
  includedInBaseRender?: boolean;
  contrastSeatingName?: string;
  contrastSteeringName?: string;
}

export interface Step {
  stepNumber: number;
  stepName: string;
  stepDescription: string;
  isTextOnly?: boolean;
  preferredView?: PreferredView;
  options: Option[];
}

export interface CarConfig {
  id: string;
  createdAt: string;
  carName: string;
  basePrice: number;
  steps: Step[];
}
